<template>
<div :class="leadInfoClass" v-show="consumerLoaded">
    <div class="lead-info-header d-flex justify-content-between">
        <div class="edit-icon" v-show="editMode">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="white" stroke-width="1px"/>
          </svg>
        </div>
        <div>Lead Information</div>
        <div class="edit-icon" v-show="editMode">
          <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="white" stroke-width="1px"/>
          </svg>
        </div>
        </div>
    <form>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="phone" class="col-form-label">Phone:</label>
            </div>
            <div class="col-sm-9">
                <input ref="phone" id="phone" type="tel" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.phone1" @input="fieldChange('phone1', $event)" v-maska="'(###) ###-####'">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.phone1">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.phone1}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="email" class="col-form-label">Email:</label>
            </div>
            <div class="col-sm-9">
                <input id="email" type="email" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.email" @input="fieldChange('email', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.email">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.email}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="ip" class="col-form-label">IP:</label>
            </div>
            <div class="col-sm-9">
                <input id="ip" type="text" class="form-control form-control-sm" disabled :value="leadInfo.ip" >
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.ip">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.ip}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="firstname" class="col-form-label">First Name:</label>
            </div>
            <div class="col-sm-9">
                <input id="firstname" type="text" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.firstname" @input="fieldChange('firstname', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.firstname">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.firstname}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="lastname" class="col-form-label">Last Name:</label>
            </div>
            <div class="col-sm-9">
                <input id="lastname" type="text" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.lastname" @input="fieldChange('lastname', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.lastname">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.lastname}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="gender" class="col-form-label">Gender:</label>
            </div>
            <div class="col-sm-9">
                <select class="form-select form-select-sm" id="gender" :value="leadInfo.gender" :disabled="!editMode" @input="fieldChange('gender', $event)">
                    <option selected :value="null">Please Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                </select>
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.gender">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.gender}}
            </div>
        </div>
        <div class="row" :class="{ 'gx-1': editMode }">
            <div class="col-3 text-center">
                <label class="col-form-label dob-label">DOB:</label>
            </div>
            <template v-if="editMode">
              <div class="col-3 month-holder">
                  <select class="form-select form-select-sm" id="birth-month" :value="leadInfo.birthMonth" :disabled="!editMode" @input="fieldChange('birthMonth', $event)">
                      <option selected :value="null">Month</option>
                      <option v-for="m in 12" :value="m" :key="m">{{m}}</option>
                  </select>
              </div>
              <div class="col-3 day-holder">
                  <select class="form-select form-select-sm" id="birth-day" :value="leadInfo.birthDay" :disabled="!editMode" @input="fieldChange('birthDay', $event)">
                      <option selected :value="null">Day</option>
                      <option v-for="d in 31" :value="d" :key="d">{{d}}</option>
                  </select>
              </div>
              <div class="col-3 year-holder">
                  <select class="form-select form-select-sm" id="birth-year" :value="leadInfo.birthYear" :disabled="!editMode" @input="fieldChange('birthYear', $event)">
                      <option selected :value="null">Year</option>
                      <option v-for="m in birthYears" :value="m" :key="m">{{m}}</option>
                  </select>
              </div>
            </template>
            <div class="col-sm-9 dob-full-text" v-else>
              <input type="text" class="form-control form-control-sm" :value="`${leadInfo.birthMonth > 9 ? leadInfo.birthMonth : '0' + leadInfo.birthMonth}-${leadInfo.birthDay > 9 ? leadInfo.birthDay : '0' + leadInfo.birthDay}-${leadInfo.birthYear}`" disabled>
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.birthMonth || leadInfo.errors.birthDay || leadInfo.errors.birthYear">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.birthMonth || leadInfo.errors.birthDay || leadInfo.errors.birthYear}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="address" class="col-form-label">Address:</label>
            </div>
            <div class="col-sm-9">
                <input id="address" type="text" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.address" @input="fieldChange('address', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.address">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.address}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="address2" class="col-form-label">Apt/Suite:</label>
            </div>
            <div class="col-sm-9">
                <input id="address2" type="text" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.address2" @input="fieldChange('address2', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.address2">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.address2}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="zip" class="col-form-label">Zip:</label>
            </div>
            <div class="col-sm-9">
                <input id="zip" type="text" class="form-control form-control-sm" :disabled="!editMode" :value="leadInfo.zip" @input="fieldChange('zip', $event)">
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.zip">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.zip}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="city" class="col-form-label">City:</label>
            </div>
            <div class="col-sm-9">
                <select class="form-select form-select-sm" id="city" :value="leadInfo.city" :disabled="!editMode" @input="fieldChange('city', $event)">
                    <option :value="null" selected>Please Select</option>
                    <option v-for="city in cityList" :value="city.alias" :key="city.id">{{city.alias}}</option>
                </select>
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.city">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.city}}
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 text-center">
                <label for="state" class="col-form-label">State:</label>
            </div>
            <div class="col-sm-9">
                <select class="form-select form-select-sm" id="state" :value="leadInfo.state" :disabled="!editMode" @input="fieldChange('state', $event)">
                    <option selected>Please Select</option>
                    <option v-for="state in stateList" :value="state.value" :key="state.id">{{state.display}}</option>
                </select>
            </div>
        </div>
        <div class="row" v-show="leadInfo.errors.state">
            <div class="col-sm-9 offset-sm-3 info-error">
                {{leadInfo.errors.state}}
            </div>
        </div>
        <input type="hidden" id="leadid_token" />
    </form>
    <div class="button-row row" v-show="showEdit">
      <div class="col offset-2">
        <div v-show="!editMode">
          <button class="btn btn-outline-secondary" v-show="leadSaved" @click="editMode=true">Edit</button>
          <img v-show="!leadSaved" :src="loadingImg" />
        </div>
        <button class="btn btn-success" v-show="editMode" @click="save" :disabled="disabledSave">Save</button>
      </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import fetchPortalJson from '../js/PortalFetchJson'

export default {
  props: ['allowEdit'],
  data () {
    var birthYears = []
    var currentYear = (new Date()).getFullYear()
    for (let k = currentYear - 84; k <= currentYear - 17; k++) {
      birthYears.push(k)
    }
    return {
      disabledSave: false,
      editMode: true,
      birthYears,
      cityList: [],
      stateList: [],
      zipError: null,
      waitingForZip: false,
      loadingImg: process.env.BASE_URL + 'loading-small.gif'
    }
  },
  methods: {
    fieldChange (name, event) {
      var value = event.target.value
      this.setField({ field: name, value })
      switch (name) {
        case 'zip':
          break
      }
    },
    async save () {
      this.disabledSave = true
      this.setField({ field: 'service_leadid', value: await this.getJornayaToken(20) })
      this.setField({ field: 'service_trusted_form', value: await this.getTrustedFormToken(20) })
      this.saveLeadInfo().then(() => {
        if (!this.hasErrors) {
          this.editMode = false
        } else {
          this.editMode = true

          if (this.leadInfo.errors.call_center_dba) {
            this.editMode = false
            this.$router.push(`/consumer/${this.consumer.id}/not-valid`)
          }
        }
      }).finally(() => {
        this.disabledSave = false
      })
    },
    async autoSave () {
      await new Promise((resolve) => setTimeout(resolve, 200))
      if (this.consumerLoaded && !this.waitingForZip) {
        if (this.leadInfo.phone1) {
          var phoneEvent = new Event('input', {
            bubbles: true,
            cancelable: true
          })
          this.$refs.phone.dispatchEvent(phoneEvent)
        }
        var ignoredKeys = ['service_leadid',
          'source_service_leadid',
          'source_service_trusted_form',
          'service_trusted_form',
          'signup_url',
          'consent_url',
          'warning',
          'address2']
        if (Object.keys(this.leadInfo).every((key) => ignoredKeys.includes(key) || this.leadInfo[key] || this.leadInfo[key] === false)) {
          this.save()
        }
      } else {
        this.autoSave()
      }
    },
    async getJornayaToken (maxTries) {
      var leadId = window.LeadiD
      if (typeof leadId !== 'undefined' && typeof leadId.token !== 'undefined' && leadId.token !== '') {
        return leadId.token
      } else {
        if (maxTries > 0) {
          await new Promise((resolve) => setTimeout(resolve, 100))
          return await this.getJornayaToken(maxTries - 1)
        } else {
          return null
        }
      }
    },
    async getTrustedFormToken (maxTries) {
      var tokenList = document.getElementsByName('xxTrustedFormCertUrl')
      if (tokenList.length > 0 && tokenList[0].value.length > 0) {
        return tokenList[0].value
      } else {
        if (maxTries > 0) {
          await new Promise((resolve) => setTimeout(resolve, 100))
          return await this.getTrustedFormToken(maxTries - 1)
        } else {
          return null
        }
      }
    },
    async getCitiesAndStates (zip) {
      this.zipError = null
      this.waitingForZip = true
      try {
        this.cityList = (await fetchPortalJson(`zip_codes?zip_code=${zip}`)).zip_codes.sort((z1, z2) => {
          var cityA = z1.alias.toUpperCase()
          var cityB = z2.alias.toUpperCase()
          if (cityA < cityB) {
            return -1
          }
          if (cityA > cityB) {
            return 1
          }
          return 0
        })
      } catch (e) {
        this.zipError = e
        this.waitingForZip = false
        return
      }
      if (this.cityList.length === 1) {
        this.setField({ field: 'city', value: this.cityList[0].alias })
      } else if (this.leadInfo.city) {
        var correctedName = this.cityList.find((city) => city.alias.toUpperCase() === this.leadInfo.city.toUpperCase())
        if (correctedName) {
          this.setField({ field: 'city', value: correctedName.alias })
        } else {
          this.setField({ field: 'city', value: null })
        }
      }
      if (this.cityList.length > 0) {
        this.setField({ field: 'state', value: this.cityList[0].state })
      }
      this.waitingForZip = false
    },
    async getStates () {
      this.stateList = (await fetchPortalJson('states?consumer_id=' + this.consumer.id)).states
    },
    ...mapActions({
      saveLeadInfo: 'consumer/saveLeadInfo'
    }),
    ...mapMutations({
      setField: 'consumer/lead/setField',
      isEditting: 'consumer/setEditingPrimaryInfo',
      addConsumerError: 'consumer/addConsumerError'
    })
  },
  computed: {
    showEdit () {
      return this.allowEdit && this.allowConsumerInfoEdit
    },
    leadInfoClass () {
      return {
        'lead-info-box': true,
        editing: this.editMode
      }
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      leadInfo: 'consumer/lead/leadInfo',
      hasErrors: 'consumer/lead/hasErrors',
      allowConsumerInfoEdit: 'consumer/allowConsumerInfoEdit',
      leadSaved: 'consumer/lead/isSaved'
    })
  },
  mounted () {
    if (this.leadInfo.zip && /(^\d{5}$)/.test(this.leadInfo.zip)) {
      this.getCitiesAndStates(this.leadInfo.zip)
    }
    this.autoSave()
  },
  watch: {
    'leadInfo.zip' (newValue) {
      if (newValue && /(^\d{5}$)/.test(newValue)) {
        this.getCitiesAndStates(newValue)
      }
    },
    'leadInfo.extraData.leadId' (newValue) {
      if (newValue && this.editMode) {
        this.editMode = false
      }
    },
    'editMode' (val) {
      this.isEditting(val)
    },
    'consumerLoaded' () {
      this.getStates()
    }
  }
}
</script>

<style scoped>
.lead-info-box {
    border: 1px solid #337ab7;
    border-radius: 3px;
    padding-bottom: 30px;
}
.lead-info-box form {
    padding: 15px;
}
.lead-info-header {
    padding: 15px 15px;
    background: #337ab7;
    color: white;
    font-size: 18px;
    font-weight: 500;
}

input.form-control:-webkit-autofill, select.form-select:-webkit-autofill {
  background-color: rgba(256,256,256,0) !important;
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}
.form-control:disabled, .form-select:disabled {
  background: none;
  border: none;
  opacity: .8;
  color: #212529;
  padding-left: 8px;
  font-size: 14px;
}
.col-sm-3 label.col-form-label {
  margin-left: calc(var(--bs-gutter-x) / -2);
  margin-right: calc(var(--bs-gutter-x) / -2);
  text-align: center;
  font-weight: 600;
}
.dob-label {
  font-weight: 600;
}
.info-error {
  color: red;
}
.form-select {
  background-position: right 0rem center;
  padding-right: 1rem;
}
.month-holder {
  padding-left: 7px;
}

</style>
